export default "/_next/static/images/dfa-logo-e92149851d16db45d7baf72166922bc0.png";